import userGoalSettingsModelDefinition from '../../user/userGoalSettings'
import goalMetaModelDefinition from '../goalMeta';

const BACKEND = 'REALTIMEDB'

export function instantiate_goal_from_template(creatorUserId, userPublic, template) {

  let goal_name = '' // TODO

  let goal = goalMetaModelDefinition.schema.create(
    { name: goal_name, creatorUserId, userPublic },
    { picture: null, TEMPLATE: false },
    BACKEND
  );

  let userGoal = userGoalSettingsModelDefinition.schema.create({
    cachedName: goal_name,
    sortidx: 0
  });

  goal.name = template.name;
  goal.objective = template.objective;
  goal.challengeId = template.id;
  goal.description = template.description;
  goal.rules = template.rules;
  goal.visibility = template.visibility;
  goal.isTeamgoal = template.isTeamgoal;
  goal.deadlineList = template.deadlineList;
  goal.tasks = template.tasks; // TODO: deep copy
  // cachedHighscore ?

  goal.picture = template.picture;
  goal.commitments = template.commitments;
  goal.lanes = template.lanes;
  goal.commitments = template.commitments; // ???

  // goal.allowToEdit = template.allowToEdit;

  userGoal.cachedName = template.name;
  userGoal.sortidx = 1;

  /* add graphical representation */
  if ( template.graphicalRepresentation ) {
    let graphicalRepresentationOverride = {
      fontFamily:       template.graphicalRepresentation.fontFamily || "Roboto",
      fontSize:         template.graphicalRepresentation.fontSize || 24,
      showHeadline:     template.graphicalRepresentation.showHeadline || true, // TODO: This will always be true !!!
      showImage:        template.graphicalRepresentation.showImage || true, // TODO: This will always be true !!!
      showCommitments:  template.graphicalRepresentation.showCommitments || true, // TODO: This will always be true !!!
      shadowColor:      template.graphicalRepresentation.shadowColor || 'black',
      shadowBlur:       template.graphicalRepresentation.shadowBlur || 25,
      shadowOffset:     template.graphicalRepresentation.shadowOffset || { x : 0, y : 5 },
      shadowOpacity:    template.graphicalRepresentation.shadowOpacity || 0.5,
    };

    userGoal.graphicalRepresentation = Object.assign(
      userGoal.graphicalRepresentation,
      graphicalRepresentationOverride
    );
  }

  /* After or before instantiation user has to assign:

  - startDate for every commitment
  - endDate for every commitment

  - deadlineList
  - update creatorUserId in tasks?
  */

  return {
    goal,
    userGoal
  }
}
